export const messagesDict = {
  instanceAlreadyExist: `Instance with name #tippyName already exist, please pick unique [tippyName]`,
  instanceNotExist: `Instance with name #tippyName does not exist`,
  childrenInstancesNotFoundGrouped: `No children tippy instances found within 'ngx-tippy-group' component`,
  childrenInstancesNotFoundSingleton: `No children tippy instances found within 'ngx-tippy-singleton' component`,
  singletonInstanceAlreadyExist: `Singleton instance with name #singletonName already exist, please pick unique [singletonName]`,
};
